import React, { FC } from "react";
import { Descriptions, Anchor } from "antd";
import moment from "moment";
import "./claimInfo.scss";

const VLAUNCH_BLOCK_EXPLORER = process.env.REACT_APP_VLAUNCH_BLOCK_EXPLORER;

interface Props {
  claimDate: string;
  claimAmount: number;
  txHash: string;
  Title: string;
}

export const ClaimInfoTable: FC<Props> = ({
  claimDate,
  claimAmount,
  txHash,
  Title,
}) => {
  const { Link } = Anchor;
  return (
    <>
      <div className="table-size">
        <Descriptions
          // column={{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }}
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}
          bordered
        >
          <Descriptions.Item className="claim-row-size" label="Project Name">
            {Title}
          </Descriptions.Item>
          <Descriptions.Item className="claim-row-size" label="Claim Date">
            {moment(claimDate).format("YYYY/MM/DD HH:mm")}
          </Descriptions.Item>
          <Descriptions.Item className="claim-row-size" label="Claim amount">
            {claimAmount}
          </Descriptions.Item>
          <Descriptions.Item
            className="claim-row-size"
            label="Transaction Hash"
          >
            <Anchor affix={false}>
              <Link
                href={`${VLAUNCH_BLOCK_EXPLORER}/tx/${txHash}`}
                title="Transaction Link"
                target="_blank"
              />
            </Anchor>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};
